import { Typography } from '@cfa/react-components';

interface NoMessageProps {
  message: React.ReactNode;
}
const NoMessage: React.FC<NoMessageProps> = ({ message }) => (
  <Typography
    className="text-grayscale-gray7! text-left text-base!"
    variant="body2"
  >
    <span dangerouslySetInnerHTML={{ __html: message as string }} />
  </Typography>
);

export default NoMessage;
